// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { Tile, TileSize, TileSizeMobile } from '../../_components/ui';
import { InnerGridWrapper } from '../_partials';
import { TeaserBoxVersion } from '../TeaserBox.contracts';
import { TeaserBoxAddonsMixin } from '../TeaserBox.shared';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let TeaserBoxInnerGrid4S = class TeaserBoxInnerGrid4S extends TeaserBoxAddonsMixin {
    constructor() {
        super(...arguments);
        this.gridConfig = {
            defaultSize: TileSize.S,
            mobileSize: TileSizeMobile.TILE,
            tiles: { 0: TileSize.S },
            listOffset: 4,
            listType: false
        };
    }
};
TeaserBoxInnerGrid4S.moduleVersion = TeaserBoxVersion['4S'];
TeaserBoxInnerGrid4S = __decorate([
    Component({
        name: 'TeaserBoxInnerGrid8S',
        components: { InnerGridWrapper, Tile },
        template: `
    <div class="teaser-box__inner-grid__scroll-wrap">
    <InnerGridWrapper class="teaser-box__inner-grid__scroll">
      <template v-for="item in tiles" v-if="items && items.length">
        <component :is="getComponentType(item)" v-bind="getComponentProps(item)" :key="item.key" />
      </template>
    </InnerGridWrapper>
    </div>
  `
    })
], TeaserBoxInnerGrid4S);
export { TeaserBoxInnerGrid4S };
